import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=2a010d32&scoped=true&"
import script from "./Datatable.vue?vue&type=script&lang=js&"
export * from "./Datatable.vue?vue&type=script&lang=js&"
import style0 from "./Datatable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Datatable.vue?vue&type=style&index=1&id=2a010d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a010d32",
  null
  
)

export default component.exports